import { Component, OnInit, AfterViewInit, NgZone, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { BrandingService } from '../Services/BrandingService';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { DxFormComponent, DxButtonComponent, DxSelectBoxComponent, DxTextBoxModule } from 'devextreme-angular';
import ValidationEngine from 'devextreme/ui/validation_engine';

import { Registration } from '../Services/Registration';
import { LanguageService } from '../Services/LanguageService';
import { SettingService } from '../Services/SettingService';
import dxForm from 'devextreme/ui/form';
import { dxValidationGroupResult } from 'devextreme/ui/validation_group';
import { TranslateService } from '@ngx-translate/core';

@Component({
    styles: [require('../../ClientApp/Register/Register.css')],
    template: require('../../ClientApp/Register/Register.html'),
    encapsulation: ViewEncapsulation.None,
    providers: [Registration, LanguageService, SettingService]
})
export class RegisterForm implements OnInit {
    @ViewChild(DxFormComponent) form: DxFormComponent;
    @ViewChild(DxButtonComponent) submitBtn: DxButtonComponent;
    maskRules: any = { "X": /[02-9]/ };
    errorMessage: string = null;
    loadIndicatorVisible: boolean = false;
    agreeToTerms: boolean = false;
    companyPattern: RegExp = /^[a-zA-Z0-9_-]*$/;
    usernamePattern: RegExp = /^[A-Za-z0-9.]+$/;
    passwordPattern: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\_\{\}\[\]\(\)'"`~,;:.<>\-+\|\?\/\\])(?=.{8,})/;
    patternMessage = '';
    company: string = 'company';
    singleTenantCompany: string | undefined;
    passwordMode: boolean;
    passwordButton: any;
    havePromotion = false;
    validPassword = false;
    newcompany = false;
    submitted = false;
    showLabel: boolean = true;
    allTranslations: any;
    checkBoxOptions: {};
    newCompanyText = 'Create new company'
    private translationSubscription: Subscription;

    public get preDefinedCompany(): string {
        if (this.singleTenantCompany !== undefined)
            return this.singleTenantCompany;
        return this._route.snapshot.queryParams['company'];
    }

    public get trialProductId() {
        return this._route.snapshot.queryParams['trialProductId'];
    }

    constructor(public branding: BrandingService,
        private _registrationService: Registration,
        private _languageService: LanguageService,
        private _router: Router,
        private _route: ActivatedRoute,
        private zone: NgZone,
        private translate: TranslateService,
        private _setting: SettingService,
        @Inject('Claims') private _claims: any) {
        this.translate.use(this._claims.UserLangCookie);
        this.translationSubscription = this.translate.getTranslation(this._claims.UserLangCookie).subscribe(translation => {
            this.allTranslations = translation;
            this.company = translation['company'];
            this.newCompanyText = translation['Create new company'];
            this.checkBoxOptions = {
                visible: true,
                onValueChanged: (e: any) => this.validateAccount(e),
                text: this.newCompanyText
            };
        });
        this.havePromotion = this._route.snapshot.queryParams['promotion'] === 'true' ? true : false;

        this.passwordMode = true;
        this.passwordButton = {
            icon: "/identity/content/icons/ShowPassword.png",
            type: "default",
            onClick: () => {
                this.passwordMode = !this.passwordMode;
            }
        };
    }

    ngOnInit() {
        this._registrationService.createRegistrationRequest().toPromise().then<any>(res => {
            if (res.Company !== undefined && res.Company !== null && res.Company.length > 0) {
                this.singleTenantCompany = res.Company;
            }
            let language: any = this.form.instance.getEditor("Language");
            language.option("dataSource", this._languageService.supportedLanguages);

            //if (this.preDefinedCompany !== undefined) {
            //    this._setting.getPasswordExpression().subscribe(res => {// should pass company name
            //        if (res !== null) {
            //            this.passwordPattern = res;
            //            if (res === /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\_\{\}\[\]\(\)'"`~,;:.<>\-+\|\?\/\\])(?=.{8,})/.source) {
            //                //this.patternMessage = 'A password has to contain at least one numeric character, one lower case character, one upper case character, and one symbol; and must be a minimum length of 8 characters.';
            //            }
            //            else {
            //                this.patternMessage = 'A password must fulfill your company\'s requirements for length and character variety. Please see your company\'s administrator for more details.';
            //            }
            //        }
            //        else {
            //            this.passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\_\{\}\[\]\(\)'"`~,;:.<>\-+\|\?\/\\])(?=.{8,})/;
            //            //this.patternMessage = 'A password has to contain at least one numeric character, one lower case character, one upper case character, and one symbol; and must be a minimum length of 8 characters.';
            //        }
            //    }, er => {
            //        this.errorMessage = er.Message;
            //    });
            //}
        }, error => {
            this.errorMessage = error._body;
        });

    }

    ngOnDestroy() {
        if (this.translationSubscription) {
            this.translationSubscription.unsubscribe();
        }
    }

    //validations
    validateCompanyComplete: boolean = true;
    validateCompany = (params: any, column: any) => {
        if (this.validateCompanyComplete == false) {
            return this._registrationService.verifyCompany(params.value).toPromise()
                .then(res => {
                    this.validateCompanyComplete = true;
                    let checkbox = this.form.instance.getEditor("NewCompany") as any;
                    if (res == false) {
                        if (checkbox !== undefined && checkbox.option("value")) {
                            this.newcompany = params.rule.isValid = true;
                        }
                        else {
                            params.rule.message = params.value + " is not registered, please confirm the company name with Administrator or create a new company if you are an administrator.";
                            this.newcompany = params.rule.isValid = false;
                            if (checkbox !== undefined) {
                                checkbox.option("visible", true);
                            }
                        }
                    }
                    else {
                        params.rule.isValid = true;
                        if (checkbox !== undefined) {
                            checkbox.option("value", false);
                            checkbox.option("visible", false);
                        }
                    }
                    return params.rule.isValid;
                }, error => {
                    params.rule.message = "Could not verify the Company name: " + error._body;
                    params.rule.isValid = false;
                    return params.rule.isValid;
                });
        }
        //TODO: update helptext
        //this.form.itemOption("Username", "helpText", "@" + params.value + ".onxmpro.com");
        return Promise.resolve(params.rule.isValid);
    }

    validateUsernameComplete: boolean = true;
    validateUsername = (params: any) => {
        const checkbox = this.form.instance.getEditor("NewCompany") as any;
        if (checkbox !== undefined && checkbox.option("value"))
            params.rule.isValid = true;
        else if (this.validateUsernameComplete == false) {
            let company = this.form.instance.option('formData')['Company'];
            return this._registrationService.verifyNewUsername(params.value, company).toPromise()
                .then(res => {
                    this.validateUsernameComplete = true;
                    params.rule.isValid = res;
                    return params.rule.isValid;
                }, error => {
                    params.rule.message = "Could not verify user name: " + error._body;
                    params.rule.isValid = false;
                    return params.rule.isValid;
                });
        }
        return Promise.resolve(params.rule.isValid);
    }

    //matchPassword = (params: any) => {
    //    let formData = this.form.instance.option('formData');
    //    return params.rule.isValid = formData['Password'] === formData['ConfirmPassword'];
    //}

    //events
    formReady = (e: { component: dxForm }) => {
        e.component.option("formData", { Company: this.preDefinedCompany });
        //this._languageService.Initialize().then(() => {
        //    let countrySelectBox = e.component.getEditor("Country");
        //    countrySelectBox.option("dataSource", this._languageService.Countries());
        //}, er => { this.errorMessage = "There were errors loading the form. Please make sure you are connected to the Internet and try again."; });

        if (this.preDefinedCompany) {
            this.validateAccount(null);
        }
    }

    validateAccount = (e) => {
        this.validateCompanyComplete
            = this.validateUsernameComplete
            = false;
        ValidationEngine.validateGroup("Account");

        if (this.form.instance !== undefined) {
            let data = this.form.instance.option("formData");
            let company: string = data.Company;
            if (company === undefined || company.trim().length === 0) {
                company = this.allTranslations['company'];
            }

            this.company = company.toLowerCase();
        }
    }

    agreeToPolicy = (e) => {
        this.agreeToTerms = e.value;
    }

    passwordChanged = (e: any) => {
        if (e.value && !(0 === e.value.length)) {
            ValidationEngine.validateGroup("Password");
        }
        const password = e.value as string;

        const numeric = /[0-9]/.test(password);
        const lower = /[a-z]/.test(password);
        const upper = /[A-Z]/.test(password);
        const special = /[!@#\$%\^&\*\_\{\}\[\]\(\)'"`~,;:.<>\-+\|\?\/\\]/.test(password);
        const length = password.length < 8 ? false : true;

        numeric ? document.getElementById("numeric").style.opacity = "1" : document.getElementById("numeric").style.opacity = "0.5";
        lower ? document.getElementById("lower").style.opacity = "1" : document.getElementById("lower").style.opacity = "0.5";
        upper ? document.getElementById("upper").style.opacity = "1" : document.getElementById("upper").style.opacity = "0.5";
        special ? document.getElementById("special").style.opacity = "1" : document.getElementById("special").style.opacity = "0.5";
        length ? document.getElementById("length").style.opacity = "1" : document.getElementById("length").style.opacity = "0.5";

        numeric ? document.getElementById("password-icon-numeric").style.display = "flex" : document.getElementById("password-icon-numeric").style.display = "none";
        lower ? document.getElementById("password-icon-lower").style.display = "flex" : document.getElementById("password-icon-lower").style.display = "none";
        upper ? document.getElementById("password-icon-upper").style.display = "flex" : document.getElementById("password-icon-upper").style.display = "none";
        special ? document.getElementById("password-icon-special").style.display = "flex" : document.getElementById("password-icon-special").style.display = "none";
        length ? document.getElementById("password-icon-length").style.display = "flex" : document.getElementById("password-icon-length").style.display = "none";

        if (numeric && lower && upper && special && length) {
            this.validPassword = true;
        }
        else {
            this.validPassword = false;
        }

    }

    //countrySelected = (e) => {
    //    let timezoneSelectBox = this.form.instance.getEditor("TimezoneName") as any;
    //    let languageSelectBox = this.form.instance.getEditor("Language") as any;
    //    //let telephoneTextBox = this.form.instance.getEditor("Telephone") as any;
    //    //var mobileTextBox = this.form.instance.getEditor("Mobile") as any;

    //    let country = this._languageService.GetCountryData(e.value);
    //    timezoneSelectBox.option("dataSource", country.descriptiveZones);
    //    languageSelectBox.option("dataSource", country.languages);
    //    //telephoneTextBox.option("mask", "+" + country.callingCodes[0].replace("9", "\\9") + " (X00) 000-0009");
    //    //mobileTextBox.option("mask", "+" + country.callingCodes[0].replace("9", "\\9") + " (X00) 000-0009");
    //    //ValidationEngine.resetGroup("Mobile"); // mobile is not required
    //}

    onSubmit = (e) => {
        const cResult = ValidationEngine.validateGroup("Account");
        const pResult = ValidationEngine.validateGroup("Password");
        const validationResult = this.form.instance.validate();
        if (validationResult.isValid && cResult.isValid && pResult.isValid) {
            this.loadIndicatorVisible = true;

            const asyncValidation: Promise<dxValidationGroupResult>[] = [];
            if (cResult.status === 'pending') {
                asyncValidation.push(cResult.complete as Promise<dxValidationGroupResult>);
            }

            if (pResult.status === 'pending') {
                asyncValidation.push(pResult.complete as Promise<dxValidationGroupResult>);
            }

            if (validationResult.status === 'pending') {
                asyncValidation.push(validationResult.complete as Promise<dxValidationGroupResult>);
            }

            let validationPromise: Promise<dxValidationGroupResult[]> = Promise.resolve([]);
            if (asyncValidation.length > 0) {
                validationPromise = Promise.all(asyncValidation);
            }

            validationPromise.then(results => {
                if (results !== undefined) {
                    for (const res of results) {
                        if (!res.isValid) {
                            this.loadIndicatorVisible = false;
                            return;
                        }
                    }
                }

                let data: any = this.form.instance.option("formData");
                data.trialProductId = this.trialProductId;
                data.Promotion = this.havePromotion ? "freetrial" : "";
                //temporary until removed or allowing null value
                data.Timezone = '';
                data.Country = '';
                data.Mobile = '';

                if (data.PhoneNumber === undefined && !data.Newsletter && data.Postcode === undefined) {
                    this.submitted = true;
                    this._registrationService.submitRegistrationRequest(data)
                        .subscribe(res => {
                            if (res.Status == true) {
                                this.zone.run(() => {
                                    this._router.navigate(['/Complete', { email: data.Email, newcompany: this.newcompany }], { relativeTo: this._route });
                                });
                            }
                            else {
                                this.errorMessage = res.Message;
                                this.loadIndicatorVisible = false;
                            }
                        }, error => {
                            this.errorMessage = error._body;
                            this.loadIndicatorVisible = false;
                            this.submitted = false;
                        });
                }
                else {
                    this.loadIndicatorVisible = false;
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Register/RegisterForm.ts